import React, { useState, useEffect } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import ButtonWithSpinner from "../ButtonWithSpinner";
import { BotaoCancelar, BotaoConfirmar } from "../BotoesModal";
import { legendaMidia } from "../../helpers/legendaMidia";

const MessageEditModal = ({ modalOpen, onClose, mensagem }) => {

	const [bodyMessage, setBodyMessage] = useState("");

	// Mídia é editada pela legenda; só o texto puro ("chat") edita o corpo.
	const ehLegenda = !!mensagem?.mediaType && mensagem.mediaType !== "chat";

	// Em mídia, parte da legenda real: `body` guarda o nome do arquivo salvo
	// quando a mídia foi sem legenda, e isso não pode ir pro campo (ver
	// helpers/legendaMidia). Antes o campo também não era limpo ao trocar de
	// mensagem, porque o if descartava body vazio.
	useEffect(() => {
		setBodyMessage(legendaMidia(mensagem));
	}, [mensagem]);

	const handleConfirmar = () => {
		onClose(bodyMessage);
	};

	// null avisa quem chamou que foi cancelado — sem isso, cancelar salvava.
	const handleCancelar = () => {
		onClose(null);
	};

	return (
		<Dialog open={modalOpen} onClose={handleCancelar} maxWidth="sm" fullWidth>
			<DialogTitle id="form-dialog-title">
				{ehLegenda ? "Editar legenda" : "Editar mensagem"}
			</DialogTitle>
			<DialogContent dividers>
				<TextField
					label={ehLegenda ? "Legenda" : "Mensagem"}
					variant="outlined"
					multiline
					fullWidth
					value={bodyMessage}
					onChange={(e) => setBodyMessage(e.target.value)}
				/>
			</DialogContent>
			<DialogActions>
				<BotaoCancelar onClick={handleCancelar}>
					Cancelar
				</BotaoCancelar>
				<BotaoConfirmar type="button" onClick={handleConfirmar}>
					Editar
				</BotaoConfirmar>
			</DialogActions>
		</Dialog>
	);
};

export default MessageEditModal;